import axios from "axios";

const baseURL = "/api/cdk/merchant/v1";

const URL = {
  listStores: `${baseURL}/list/stores`,
  list: `${baseURL}/list`
};

const HEADERS = {
  "Content-Type": "application/json"
};

const MerchantsService = {
  getMerchants: async () => {
    const response = await axios.get(`${URL.list}`, { headers: HEADERS });
    return response.data;
  },
  getMerchant: async id => {
    const response = await axios.get(`${baseURL}/${id}`, { headers: HEADERS });
    return response.data;
  },
  createMerchant: async merchant => {
    const response = await axios.post(`${baseURL}/`, merchant, {
      headers: HEADERS
    });
    return response.data;
  },
  updateMerchant: async merchant => {
    const response = await axios.put(`${baseURL}/`, merchant, {
      headers: HEADERS
    });
    return response.data;
  },
  deleteMerchant: async merchant => {
    const { id } = merchant;
    const response = await axios.delete(`${baseURL}/${id}`, {
      headers: HEADERS
    });
    return response.data;
  }
};

export default MerchantsService;
